<template>
  <div>
    <el-button
      v-if="admin"
      type="primary"
      size="small"
      v-code="51301"
      @click.native="handleEdit()"
      >添加 旧{{ commodityCategory.name }} 入库</el-button
    >

    <el-table :data="items">
      <el-table-column label="材料名称" prop="commodity.name" align="center">
      </el-table-column>
      <!-- <el-table-column align="center" label="新 / 旧">
        <template slot-scope="scope">
          {{ scope.row.category == 1 ? '新齿' : '旧齿' }}
        </template>
      </el-table-column> -->

      <el-table-column label="存货编码" prop="commodity.code" align="center">
      </el-table-column>
      <el-table-column
        label="规格"
        prop="commodity.specification"
        align="center"
      >
      </el-table-column>
      <el-table-column
        :label="commodityCategory.id == 2 ? '倒角' : '型号'"
        prop="commodity.model_number"
        align="center"
      >
      </el-table-column>
      <template v-if="commodityCategory.id == 2">
        <el-table-column
          label="齿形"
          prop="commodity.tooth_type"
          align="center"
        >
        </el-table-column>
        <el-table-column label="尺寸" prop="commodity.size" align="center">
        </el-table-column>
      </template>
      <!-- <el-table-column
        align="center"
        label="供应方"
        prop="supplier"
      ></el-table-column>
      <el-table-column
        align="center"
        label="到货日期"
        prop="arrive_date"
        min-width="100"
      ></el-table-column>
      <el-table-column
        align="center"
        label="到货批次"
        prop="arrive_batch"
      ></el-table-column> -->
      <!-- <el-table-column align="center" label="单价">
        <template slot-scope="scope">
          {{ scope.row.price.toFixed(2) }}
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        label="数量"
        prop="number"
      ></el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span
            class="label"
            :class="scope.row.status == 1 ? 'label-warning' : 'label-success'"
          >
            {{ scope.row.status == 1 ? '未入库' : '已入库' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="入库时间" align="center" min-width="100">
        <template slot-scope="scope">
          {{
            scope.row.confirm_time
              ? $time(scope.row.confirm_time).format('YYYY-MM-DD')
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column label="入库类型" align="center" min-width="100">
        <template slot-scope="scope">
          {{ ItemStockInCategoryMap[scope.row.stock_in_category] }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="160" v-if="admin">
        <template slot-scope="scope">
          <template v-if="scope.row.status == 1">
            <btn-tag
              :btn="true"
              text="编辑"
              :key="Math.random()"
              :auth-id="51301"
              module-name="stock"
              @click.native="handleEdit(scope.row, scope.$index)"
            ></btn-tag>
            <btn-tag
              :btn="true"
              text="删除"
              :key="Math.random()"
              :auth-id="51301"
              module-name="stock"
              btn-class="btn-danger"
              @click.native="hanldeDelte(scope.row, scope.$index)"
            ></btn-tag>
            <btn-tag
              :btn="true"
              text="确认入库"
              :key="Math.random()"
              :auth-id="51301"
              module-name="stock"
              btn-class="btn-warning"
              @click.native="hanldeConfirmStockIn(scope.row, scope.$index)"
            ></btn-tag>
          </template>
          <template v-else>-</template>
        </template>
      </el-table-column>
    </el-table>
    <item-in-former
      :model="model"
      :commodityCategory="commodityCategory"
      :show.sync="formerVisible"
      @callback="callback"
    ></item-in-former>
  </div>
</template>

<script>
import { itemInRecordDelete, itemInRecordConfirm } from '@/service/getData'
import ItemInFormer from '@/components/item_in_former'
import { ItemStockInCategoryMap } from '@/config/global'

export default {
  components: {
    ItemInFormer,
  },
  props: {
    items: null,
    admin: false,
    commodityCategory: Object,
  },
  data() {
    return {
      ItemStockInCategoryMap,
      model: {
        commodity_id: '',
        commodity_category: 0,
        stock_in_category: 2,
        category: 2,
        supplier: '',
        arrive_date: '',
        arrive_batch: '',
        number: 1,
        remark: '',
      },
      formerVisible: false,
      editIndex: 0,
    }
  },
  methods: {
    hanldeDelte(item, index) {
      let that = this
      that.$dialog.confirm('确认删除吗').then(function (dialog) {
        itemInRecordDelete(item.id).then((res) => {
          if (res.status == 0) {
            that.items.splice(index, 1)
          }
        })
      })
    },
    handleEdit(item, index) {
      this.formerVisible = true
      this.$nextTick(() => {
        if (!item) {
          this.editIndex = -1
          this.model = {
            commodity_id: '',
            commodity_category: this.commodityCategory.id,
            stock_in_category: 2,
            category: 2,
            supplier: '',
            arrive_date: '',
            arrive_batch: '',
            number: 1,
            remark: '',
            created: true,
          }
        } else {
          this.model = this.clone(item)
          this.model.created = true
          this.editIndex = index
        }
      })
    },
    callback(data) {
      if (this.editIndex == -1) {
        this.items.unshift(data)
      } else {
        this.$set(this.items, this.editIndex, data)
      }
    },
    hanldeConfirmStockIn(item, index) {
      let that = this
      this.$confirm('确认入库吗?', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await itemInRecordConfirm(item.id)
          if (res.status == 0) {
            that.$set(that.items, index, res.data)
          }
        })
        .catch(() => {})
    },
  },
}
</script>